class DropdownButtons {
    constructor() {
        this.buttonEls = document.querySelectorAll('.dropdown')
        this.dropdownButtons = []

        this.init()
    }

    init() {
        this.buttonEls.forEach((buttonEl, index) => {
            buttonEl.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()
                this.toggleDropdown(index)
            })

            this.dropdownButtons.push({
                el: buttonEl,
                menu: buttonEl.querySelector('.dropdown-content'),
                open: false
            })
        })
    }

    toggleDropdown (index) {
        if(this.dropdownButtons[index].open) {
            this.closeDropdown(index)
        } else {
            this.openDropdown(index)
        }
    }

    hideOnClickOutside(index) {
        const removeClickListener = () => {
            document.removeEventListener('click', outsideClickListener)
        }

        const outsideClickListener = (e) => {
            if (!this.dropdownButtons[index].el.contains(e.target)) {
                this.closeDropdown(index)
                removeClickListener()
            }
        }

        document.addEventListener('click', outsideClickListener)
    }

    openDropdown (index) {
        this.dropdownButtons.forEach((button, index) => {
            if(button.open) {
                this.closeDropdown(index)
            }
        })

        this.dropdownButtons[index].menu.style.display = 'block'
        this.dropdownButtons[index].open = true

        this.hideOnClickOutside(index)
    }

    closeDropdown (index) {
        this.dropdownButtons[index].menu.style.display = 'none'
        this.dropdownButtons[index].open = false
    }
}

export default DropdownButtons
